/**
 * Generates a URL-friendly slug for an event
 * @param {Object} event - The event object containing startDate, organization, and title
 * @returns {string} URL-friendly slug
 */
export const generateEventSlug = (event) => {
    const eventDate = new Date(event.startDate);
    return `${eventDate.getFullYear()}-${String(eventDate.getMonth() + 1).padStart(2, '0')}-${String(eventDate.getDate()).padStart(2, '0')}-${encodeURIComponent(event.organization)}-${encodeURIComponent(event.title)}`.toLowerCase();
};

/**
 * Creates a local YYYY-MM-DD key from a Date or date-like value.
 * @param {Date|string|number} dateInput - Date-like input
 * @returns {string|null} Local date key or null for invalid dates
 */
export const getLocalDateKey = (dateInput) => {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    if (Number.isNaN(date.getTime())) {
        return null;
    }

    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

/**
 * Parses a slug to extract date information
 * @param {string} slug - The event slug
 * @returns {Object|null} Object containing year and month, or null if invalid
 */
export const parseEventSlug = (slug) => {
    try {
        const parts = slug.split('-');
        if (parts.length >= 3) {
            const year = parseInt(parts[0]);
            const month = parseInt(parts[1]);
            const day = parseInt(parts[2]);
            if (!isNaN(year) && !isNaN(month) && !isNaN(day) && 
                month >= 1 && month <= 12 && day >= 1 && day <= 31) {
                return { year, month, day };
            }
        }
        return null;
    } catch (error) {
        //console.error('Error parsing event slug:', error);
        return null;
    }
}; 